<template>
  <div class='integration-widget' @click='integrationClicked'>
    <div class="integration-widget__name">
      {{ integrationName.toUpperCase() }}
    </div>
    <v-divider />
    <div class="integration-widget__description">
      {{ integrationShortDescription }}
    </div>
    <div class="integration-widget__icon_section">
      <v-chip class='integration-widget__icon_section__category'
              v-text='integrationCategory'
              label
              x-small
      />
      <div class='icon' v-html="integrationIcon"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntegrationWidget',
  props: {
    integrationData: {
      required: true,
    },
  },
  methods: {
    integrationClicked() {
      this.$emit('integrationClicked', this.integrationData);
    },
  },
  computed: {
    integrationShortDescription() {
      return this.integrationData.shortDescription || '';
    },
    integrationName() {
      return this.integrationData.displayName || '';
    },
    integrationIcon() {
      return this.integrationData.icon || '';
    },
    integrationCategory() {
      return this.$t(`integration.category.${this.integrationData.category.toLowerCase()}`);
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.integration-widget {
  position: relative;
  background-color: var(--bg-primary);
  border: 1px solid var(--border-primary);
  border-radius: $radius-md;
  box-shadow: 0 0 8px 0 rgba(26, 30, 34, 0.08);
  margin-bottom: $space-2-5;
  margin-right: $space-2-5;
  width: 310px;
  height: 260px;
  padding: 23px 31px 23px 31px;
  display: flex;
  flex-direction: column;
  &__name {
    color: var(--text-primary);
    font-family: $font-family-medium;
    font-size: $font-size-md;
    font-weight: 500;
    letter-spacing: 0;
    line-height: $font-size-md;
    margin-bottom: 5px;
  }
  &__description {
    margin-top: $space-5;
    color: var(--text-secondary);
    font-family: $font-family-regular;
    font-size: $font-size-base;
    line-height: 1.5em;
    flex: 1;
  }
  &__icon_section {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    .icon {
      display: flex;
      width: 48px;
    }
    &__category{
      font-family: $font-family-regular;
    }
  }
  &:hover {
    cursor: pointer;
    border: $good-button-hover-border;
    background-color: $good-button-hover-background-color !important;
  }
  &:active{
    border: $good-button-active-border;
    background-color: $good-button-hover-background-color !important;
  }
}
</style>
